import { MimeType } from 'src/common/types';

export const securityFormName = 'security';

export const AVATAR_SUPPORTED_FORMATS = ['.jpg', '.png', '.gif'];
export const AVATAR_SUPPORTED_UPLOAD_FORMATS = [MimeType.jpeg, MimeType.png, MimeType.gif];

export const AVATAR_MAX_SIZE = 1024 * 1024 * 2;
